import React from 'react';

// https://uxplanet.org/using-loading-animation-on-websites-and-apps-examples-and-snippets-to-use-cab0097be9f1
export const LoadingIndicator: React.FunctionComponent<{}> = () => {
    return (
        <div className="loading-container">
            <div className="loader">
                <div className="loader--dot"/>
                <div className="loader--dot"/>
                <div className="loader--dot"/>
                <div className="loader--dot"/>
                <div className="loader--dot"/>
                <div className="loader--dot"/>
                <div className="loader--text"/>
            </div>
        </div>
    );
};
